import ApiDrivenModel from "./ApiDrivenModel"
export default class Organization extends ApiDrivenModel {
	static ENDPOINT = "/Organization";
	static PATHS = {
		id: true,
		name: true,
		handle: true,
		formatted_address: true,
		features: true,
		catalog_access: true,
		phone: true,
		address: true,
		locality: true,
		administrative_area: true,
		postal_code: true,
		country: true,
		logo: true,
		branding: true,
		email_domains: true,
		parent: true,
		website: true,
	};

	async linkAssociate(associate) {
		try {
			const { success, result } = await Organization.Call({
				name: "Link_Associate",
				payload: {
					associate,
					organization: this.id,
				}
			});

			if (success) {
				const { success } = result;
				return { success };
			}
		} catch ( /** @type CustomError */ e) {
			console.warn("Failed to link associate", e.data);
		}

		return { success: false };
	}
}
